import { render, staticRenderFns } from "./RateChange.vue?vue&type=template&id=488b34c4&scoped=true&"
import script from "./RateChange.vue?vue&type=script&lang=js&"
export * from "./RateChange.vue?vue&type=script&lang=js&"
import style0 from "./RateChange.vue?vue&type=style&index=0&id=488b34c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b34c4",
  null
  
)

export default component.exports